<div class="ingest-shell">
  <router-outlet />
</div>
